import { BackArrow } from 'lib/styles/icons';
import palette from 'lib/styles/palette';
import { useState } from 'react';
import styled, { css } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import * as authAPI from 'lib/api/auth';
import Modal from 'components/common/Modal';

const ResetPasswordForm = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [isModal, setModal] = useState(false);

  const onChangeCode = e => {
    setCode(e.target.value);
  };

  const onChangeEmail = e => {
    setEmail(e.target.value);
  };

  return (
    <Background>
      {isModal && (
        <Modal>
          <Box style={{ width: 300 }}>
            <div style={{ fontWeight: 'bold' }}>temp</div>
            <StyledButton
              style={{ width: 100, marginTop: 30 }}
              canGoNext
              onClick={() => navigate('/')}
            >
              확인
            </StyledButton>
          </Box>
        </Modal>
      )}
      <Box>
        <div className="top-wrapper">
          <div className="title">비밀번호 재설정</div>
          <BackArrow className="back-arrow" onClick={() => navigate(-1)} />
        </div>
        <div className="email-input-wrapper">
          <StyledInput
            type="email"
            placeholder="이메일을 입력하세요"
            autoFocus
            onChange={onChangeEmail}
            style={{ width: 280 }}
          />
          <SmallButton disabled={!code.trim()}>전송</SmallButton>
        </div>
        <StyledInput
          type="text"
          placeholder="코드를 입력하세요"
          onChange={onChangeCode}
        />
        {error && <div className="error">{error}</div>}
        <StyledButton disabled={!email.trim()}>확인</StyledButton>
      </Box>
    </Background>
  );
};

export default ResetPasswordForm;

const Background = styled.div`
  height: 100%;
  background-color: ${palette.background};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Box = styled.div`
  width: 500px;
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: solid 1px rgba(0, 0, 0, 0.08);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.04);

  .top-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    height: 100%;
    margin-bottom: 30px;

    .title {
      font-size: 22px;
      font-weight: bold;
    }

    .back-arrow {
      position: absolute;
      left: 180px;
      font-size: 20px;
    }
  }

  .email-input-wrapper {
    width: 330px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .error {
    margin-top: 10px;
    color: red;
    font-size: 14px;
  }
`;

const StyledInput = styled.input`
  width: 330px;
  height: 50px;
  border-radius: 11px;
  border: solid 1px #dfdfdf;
  background: #fff;
  padding: 15px;
  font-size: 16px;
  &::placeholder {
    color: #c6c6c6;
  }
`;

const StyledButton = styled.button`
  width: 330px;
  height: 40px;
  margin-top: 15px;
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  ${props =>
    props.canGoNext
      ? css`
          background: ${palette.theme[2]};
          &:hover {
            background: ${palette.theme[3]};
          }
        `
      : css`
          background: ${palette.theme[0]};
        `}
`;

const SmallButton = styled.button`
  height: 38px;
  padding: 0 10px;
  border: none;
  border-radius: 8px;
  color: white;

  cursor: pointer;
  ${props =>
    props.canGoNext
      ? css`
          background: ${palette.theme[2]};
          &:hover {
            background: ${palette.theme[3]};
          }
        `
      : css`
          background: ${palette.theme[0]};
        `}
`;
